module.exports = __webpack_public_path__ + "static/ballet_shop-dfa64441114993662c037d91793528d7.jpg";